import { render, staticRenderFns } from "./CartDesktop.vue?vue&type=template&id=341e4212"
import script from "./CartDesktop.vue?vue&type=script&lang=js"
export * from "./CartDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports